import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import '../../../components/core/BannerHome/BannerHome.css';




interface BannerHomeProps {
   
  }
  
  const BannerHome: FC<BannerHomeProps> = () => (
    <div className="BannerHome-container">
        <div className="Banner-Home-container">
        <section className="pds-welcomeBanner pds-typography-center pds-welcomeBanner-background-gradient pds-color-font-neutral-white">
  <h2 className="pds-welcomeBanner-header">Bienvenido al Repositorio Documental</h2>
  <p className="pds-welcomeBanner-message">Por favor ingresa con tu email y contraseña, no olvides tener a mano microsoft authenticator.</p>
</section>
      </div>
    </div>
  );
  
  export default BannerHome;